import * as React from 'react';

export default function BinanceSmartChain(props) {
  const { width = 150, height = 150, primary = "#F0B90B" } = props;
  
  // BSC logo is circular, so maintain 1:1 aspect ratio
  const actualHeight = height || width;

  // No padding - use 24x24 viewBox to match other logos
  const padding = 0;
  const viewBoxWidth = 24;
  const viewBoxHeight = 24;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={actualHeight}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none">
      {/* Background circle with brand color */}
      <circle 
        cx={viewBoxWidth / 2} 
        cy={viewBoxHeight / 2} 
        r={viewBoxWidth / 2}
        fill={primary}
      />
      <g transform={`translate(4, 3)`}>
        {/* Official BNB logo path */}
        <path 
          d="M3.05069 2.76695L7.90323 0L12.7558 2.76695L10.9717 3.78914L7.90323 2.04438L4.83472 3.78914L3.05069 2.76695ZM12.7558 6.25649L10.9717 5.2343L7.90323 6.97907L4.83472 5.2343L3.05069 6.25649V8.30087L6.1192 10.0456V13.5352L7.90323 14.5574L9.68725 13.5352V10.0456L12.7558 8.30087V6.25649ZM12.7558 11.7904V9.74603L10.9717 10.7682V12.8126L12.7558 11.7904ZM14.0224 12.513L10.9539 14.2577V16.3021L15.8065 13.5352V8.00126L14.0224 9.02345V12.513ZM12.2384 4.51172L14.0224 5.53391V7.57828L15.8065 6.5561V4.51172L14.0224 3.48954L12.2384 4.51172ZM6.1192 14.998V17.0423L7.90323 18.0645L9.68725 17.0423V14.998L7.90323 16.0201L6.1192 14.998ZM3.05069 11.7904L4.83472 12.8126V10.7682L3.05069 9.74603V11.7904ZM6.1192 4.51172L7.90323 5.53391L9.68725 4.51172L7.90323 3.48954L6.1192 4.51172ZM1.78402 5.53391L3.56804 4.51172L1.78402 3.48954L0 4.51172V6.5561L1.78402 7.57828V5.53391ZM1.78402 9.02345L0 8.00126V13.5352L4.85253 16.3021V14.2577L1.78402 12.513V9.02345Z" 
          fill="white"
        />
      </g>
    </svg>
  );
}